import { call, put, takeEvery } from "redux-saga/effects";
import { IDmLoaiDangKyHoc } from "../../../model/respone/category/IDmLoaiDangKyHoc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDmLoaiDangKyHocActionIds,
  IDmLoaiDangKyHocActionTypes,
} from "../../action-types/category/IDmLoaiDangKyHocActions";
import { rootActions } from "../../actions/rootActions";
import { dmLoaiDangKyHocApi } from "../../../api/category/dmLoaiDangKyHocApi";

const mainAction = rootActions.category.loaiDangKyHoc;

export function* dmLoaiDangKyHocSaga(): any {
  yield takeEvery(eDmLoaiDangKyHocActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmLoaiDangKyHocActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmLoaiDangKyHocActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(dmLoaiDangKyHocApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDmLoaiDangKyHocActionTypes): any {
  const payload = action.payload as IDmLoaiDangKyHoc;
  let res: IBaseRespone;
  if (payload.id_loai_dang_ky > 0) {
    res = yield call(dmLoaiDangKyHocApi.Update, payload);
  } else {
    res = yield call(dmLoaiDangKyHocApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IDmLoaiDangKyHocActionTypes): any {
  const res: IBaseRespone = yield call(
    dmLoaiDangKyHocApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
